import React, { forwardRef } from 'react'
import type { KibButtonNewProps } from '@chewy/kib-controls-react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import classNames from 'classnames'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapTextButton.module.scss'

export type RhapTextButtonProps = KibButtonNewProps & {
  plainHover?: boolean
}

const RhapTextButton = forwardRef<HTMLButtonElement, RhapTextButtonProps>(
  ({ className, plainHover = false, emphasis, ...props }, ref) => (
    <KibButtonNew
      {...props}
      className={classNames(
        styles.textButton,
        { [styles.plainHover]: plainHover },
        { [styles.primaryEmphasis]: emphasis === 'primary' },
        className,
      )}
      emphasis={emphasis}
      ref={ref}
    />
  ),
)

RhapTextButton.displayName = 'RhapTextButton'

export default RhapTextButton
